import * as types from './actionTypes'
import { rosterService } from '../_services'
import { branchService } from '../_services'
import { departmentService } from '../_services'
import { employeeService } from '../_services'
import { toast } from 'react-toastify'

toast.configure()

export function updateCurrentDate(cond) {
    return async dispatch => {
        return dispatch({ type: types.UPDATE_CURRENT_DATE, payload: cond })
    }
}

export function setEditMode(isEditMode) {
    return async dispatch => {
        return dispatch({ type: types.SET_EDIT_MODE, payload: !!isEditMode })
    }
}

export function updateCurrentWeekDate(cond) {
    return async dispatch => {
        return dispatch({ type: types.UPDATE_CURRENT_WEEK_DATE, payload: cond })
    }
}

export function selectEmployee(id) {
    return dispatch => {
        return dispatch(success(id))
    }

    function success(id) {
        return { type: types.SELECT_EMPLOYEE, payload: id }
    }
}

export function selectEmployees(ids) {
    return async dispatch => {
        return dispatch({ type: types.SELECT_EMPLOYEES, payload: ids })
    }
}

export function selectBranches(ids) {
    return async dispatch => {
        return dispatch({ type: types.SELECT_BRANCHES, payload: ids })
    }
}

export function selectDepartments(ids) {
    return async dispatch => {
        return dispatch({ type: types.SELECT_DEPARTMENTS, payload: ids })
    }
}

export function updateDisplayEvents(cond) {
    return dispatch => {
        return dispatch({ type: types.UPDATE_DISPLAY_ETIME, cond: cond })
    }
}

export function updateDisplayRoster(cond) {
    return dispatch => {
        return dispatch({ type: types.UPDATE_DISPLAY_ROSTER, cond: cond })
    }
}

export function updateWeeklyReportEvents(options) {
    return function(dispatch) {
        return rosterService
            .fetchETime(options)
            .then(currentUserETimePayload => {
                dispatch(success(currentUserETimePayload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.UPDATE_WEEKLY_REPORT_EVENTS, payload: payload }
    }
    function failure(error) {
        return { type: types.UPDATE_WEEKLY_REPORT_EVENTS_FAILURE, error }
    }
}

export function updateWeeklyReportDisplayEvents(cond) {
    return dispatch => {
        return dispatch({
            type: types.UPDATE_WEEKLY_RPT_DISPLAY_ETIME,
            cond: cond,
        })
    }
}

export function updateDailyReportEvents(options) {
    return dispatch => {
        rosterService
            .fetchETime(options)
            .then(currentUserETimePayload => {
                dispatch(success(currentUserETimePayload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }
    function success(payload) {
        return { type: types.UPDATE_DAILY_REPORT_EVENTS, payload: payload }
    }
    function failure(error) {
        return { type: types.UPDATE_DAILY_REPORT_EVENTS_FAILURE, error }
    }
}

export function updateDailyReportDisplayEvents(cond) {
    return dispatch => {
        return dispatch({
            type: types.UPDATE_DAILY_RPT_DISPLAY_ETIME,
            cond: cond,
        })
    }
}

export function updateLeaveReportEvents(options) {
    return dispatch => {
        rosterService
            .fetchETime(options)
            .then(currentUserETimePayload => {
                dispatch(success(currentUserETimePayload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }
    function success(payload) {
        return { type: types.UPDATE_LEAVE_REPORT_EVENTS, payload: payload }
    }
    function failure(error) {
        return { type: types.UPDATE_LEAVE_REPORT_EVENTS_FAILURE, error }
    }
}

export function updateSummaryReportEvents(options) {
    return dispatch => {
        rosterService
            .fetchETime(options)
            .then(currentUserETimePayload => {
                dispatch(success(currentUserETimePayload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }
    function success(payload) {
        return {
            type: types.UPDATE_SUMMARY_REPORT_EVENTS,
            payload: payload,
            options: options,
        }
    }
    function failure(error) {
        return { type: types.UPDATE_SUMMARY_REPORT_EVENTS_FAILURE, error }
    }
}

export function updateLeaveReportDisplayEvents(cond) {
    return dispatch => {
        return dispatch({
            type: types.UPDATE_LEAVE_RPT_DISPLAY_ETIME,
            cond: cond,
        })
    }
}

export function updateSummaryReportDisplayEvents(cond) {
    return dispatch => {
        return dispatch({
            type: types.UPDATE_SUMMARY_RPT_DISPLAY_ETIME,
            cond: cond,
        })
    }
}

export function transformSummaryReportDisplayEvents(range) {
    return dispatch => {
        return dispatch({
            type: types.TRANSFORM_SUMMARY_RPT_DISPLAY_ETIME,
            cond: range,
        })
    }
}

export function updateWorkAbsenceViewDisplayEvents(cond) {
    return dispatch => {
        return dispatch({ type: types.UPDATE_WAVIEW_DISPLAY_ETIME, cond: cond })
    }
}

export function updateWorkAbsenceEvents(cond) {
    return dispatch => {
        return dispatch({ type: types.UPDATE_WORK_ABSENCE_EVENTS, cond: cond })
    }
}

export function updateDisplayEmployee(cond) {
    return async dispatch => {
        dispatch({ type: types.UPDATE_DISPLAY_EMPLOYEE, cond: cond })
    }
}

// export function updateDisplayEmployee(cond) {
//     return { type: types.UPDATE_DISPLAY_EMPLOYEE, cond: cond }
// }

// export function updateDisplayEmployee(cond, dispatch) {
//     return dispatch({ type: types.UPDATE_DISPLAY_EMPLOYEE, cond: cond })
// }

export function updateDisplayEventsByBranchDept(cond) {
    return dispatch => {
        dispatch({ type: types.UPDATE_DISPLAY_ETIME, cond: cond })
    }
}

export function updateDisplayEmployeeLeaveRPT(cond) {
    return dispatch => {
        dispatch({ type: types.UPDATE_DISPLAY_EMPLOYEE_LEAVERPT, cond: cond })
    }
}

export function filterWeeklyReportInfo(cond) {
    return dispatch => {
        dispatch({ type: types.FILTER_WEEKLY_REPORT_INFO, cond: cond })
    }
}

export function filterDailyReportInfo(cond) {
    return dispatch => {
        dispatch({ type: types.FILTER_DAILY_REPORT_INFO, cond: cond })
    }
}

export function filterLeaveReportInfo(cond) {
    return dispatch => {
        dispatch({ type: types.FILTER_LEAVE_REPORT_INFO, cond: cond })
    }
}

export function filterSummaryReportInfo(cond) {
    return dispatch => {
        dispatch({ type: types.FILTER_SUMMARY_REPORT_INFO, cond: cond })
    }
}

export function fetchEmployeeList() {
    return dispatch => {
        return employeeService
            .getAllEmployee()
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.FETCH_EMPLOYEE_LIST, payload: payload }
    }
    function failure(error) {
        return { type: types.FETCH_EMPLOYEE_LIST_FAILURE, error }
    }
}

export function fetchBranchList() {
    return dispatch => {
        return branchService
            .getAllBranch()
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.FETCH_BRANCHLIST, payload: payload }
    }
    function failure(error) {
        return { type: types.FETCH_BRANCHLIST_FAILURE, error }
    }
}

export function fetchDepartmentList() {
    return dispatch => {
        return departmentService
            .getAllDepartments()
            .then(payload => {
                dispatch(success(payload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.FETCH_DEPARTMENTSLIST, payload: payload }
    }
    function failure(error) {
        return { type: types.FETCH_DEPARTMENTSLIST_FAILURE, error }
    }
}

export function fetchUserETime(options) {
    return function(dispatch) {
        return rosterService
            .fetchETime(options)
            .then(currentUserETimePayload => {
                dispatch(success(currentUserETimePayload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.FETCH_ROSTER_USER_ETIME, payload: payload }
    }
    function failure(error) {
        return { type: types.FETCH_ROSTER_USER_ETIME_FAILURE, error }
    }
}

export function fetchUpdateUserETime(options) {
    return function(dispatch) {
        return rosterService
            .fetchETime(options)
            .then(currentUserETimePayload => {
                dispatch(success(currentUserETimePayload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.FETCH_UPDATE_ROSTER_USER_ETIME, payload: payload }
    }
    function failure(error) {
        return { type: types.FETCH_UPDATE_ROSTER_USER_ETIME_FAILURE, error }
    }
}

export function updateDisplayWeekRoster(payload) {
    return async dispatch => {
        return dispatch({ type: types.UPDATE_WORK_EVENTS, payload: payload })
    }
}

export function fetchUpdateWorkETime(options) {
    return function(dispatch) {
        return rosterService
            .fetchETime(options)
            .then(currentUserETimePayload => {
                dispatch(success(currentUserETimePayload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.UPDATE_WORK_EVENTS, payload: payload }
    }
    function failure(error) {
        return { type: types.UPDATE_WORK_EVENTS_FAILURE, error }
    }
}

export function selectDateRangeFilter(payload) {
    return async dispatch => {
        return dispatch({ type: types.SELECT_DATE_RANGE_FILTER, payload })
    }
}

export function updateWeekEvent(evt, employeeId) {
    return function(dispatch) {
        return rosterService
            .updateOne(evt)
            .then(currentUserETimePayload => {
                dispatch(success(currentUserETimePayload))
            })
            .catch(error => {
                toast.error(error.toString(), {
                    position: 'top-center',
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                })
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.UPDATE_WEEK_EVENTS, payload: payload }
    }
    function failure(error) {
        return { type: types.UPDATE_WEEK_EVENTS_FAILURE, error }
    }
}

/**
 * PUT /api/etime/preview — updates a roster record from the preview modal.
 * Returns a promise so the caller can handle loading/error state directly.
 */
export function updatePreviewEvent(payload) {
    return function(dispatch) {
        return rosterService
            .updatePreviewEvent(payload)
            .then(data => {
                dispatch({ type: types.UPDATE_WEEK_EVENTS, payload: data })
                return { success: true }
            })
            .catch(error => {
                dispatch({ type: types.UPDATE_WEEK_EVENTS_FAILURE, error: error.toString() })
                return { success: false, error: error.toString() }
            })
    }
}

/**
 * DELETE /api/etime/preview — deletes a roster record from the preview modal.
 * Returns a promise so the caller can handle loading/error state directly.
 */
export function deletePreviewEvent(rosterAutoID) {
    return function(dispatch) {
        return rosterService
            .deletePreviewEvent(rosterAutoID)
            .then(data => {
                dispatch({ type: types.REMOVE_ROSTER_ETIME, payload: { id: rosterAutoID } })
                return { success: true }
            })
            .catch(error => {
                dispatch({ type: types.REMOVE_ROSTER_ETIME_FAILURE, error: error.toString() })
                return { success: false, error: error.toString() }
            })
    }
}

export function fetchUpdateAbsenceETime(options) {
    return function(dispatch) {
        return rosterService
            .fetchETime(options)
            .then(currentUserETimePayload => {
                dispatch(success(currentUserETimePayload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.UPDATE_ABSENCE_EVENTS, payload: payload }
    }
    function failure(error) {
        return { type: types.UPDATE_ABSENCE_EVENTS_FAILURE, error }
    }
}

export function updateEvent(evt, employeeId) {
    return function(dispatch) {
        return rosterService
            .updateEvent(evt)
            .then(currentUserETimePayload => {
                dispatch(success(currentUserETimePayload))
                dispatch(updateWorkAbsenceEvents(employeeId))
            })
            .catch(error => {
                toast.error(error.toString(), {
                    position: 'top-center',
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                })
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.UPDATE_ROSTER_ETIME, payload: payload }
    }
    function failure(error) {
        return { type: types.UPDATE_ROSTER_ETIME_FAILURE, error }
    }
}

export function updateOne(evt, weekView) {
    return function(dispatch) {
        return rosterService
            .updateOne(evt)
            .then(currentUserETimePayload => {
                if (weekView) {
                    dispatch({
                        type: types.UPDATE_WEEK_EVENTS,
                        payload: currentUserETimePayload,
                    })
                } else {
                    dispatch(success(currentUserETimePayload))
                }
            })
            .catch(error => {
                toast.error(error.toString(), {
                    position: 'top-center',
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                })
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.UPDATE_ROSTER_ETIME, payload: payload }
    }
    function failure(error) {
        return { type: types.UPDATE_ROSTER_ETIME_FAILURE, error }
    }
}

export function addEvent(evt, weekView) {
    return function(dispatch) {
        return rosterService
            .addEvent(evt)
            .then(currentUserETimePayload => {
                if (weekView) {
                    dispatch({
                        type: types.UPDATE_WEEK_EVENTS,
                        payload: currentUserETimePayload,
                    })
                } else {
                    dispatch(success(currentUserETimePayload))
                }
            })
            .catch(error => {
                toast.error(error.toString(), {
                    position: 'top-center',
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                })
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.UPDATE_ROSTER_ETIME, payload: payload }
    }
    function failure(error) {
        return { type: types.UPDATE_ROSTER_ETIME_FAILURE, error }
    }
}

export function addEventMulti(evt) {
    return function(dispatch) {
        return rosterService
            .addEventMulti(evt)
            .then(currentUserETimePayload => {
                dispatch(success(currentUserETimePayload))
            })
            .catch(error => {
                toast.error(error.toString(), {
                    position: 'top-center',
                    autoClose: 3000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                })
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.UPDATE_ROSTER_ETIME, payload: payload }
    }
    function failure(error) {
        return { type: types.UPDATE_ROSTER_ETIME_FAILURE, error }
    }
}

export function removeEventById(evtId, employeeId) {
    return function(dispatch) {
        return rosterService
            .removeEventById(evtId)
            .then(currentUserETimePayload => {
                dispatch(success(currentUserETimePayload))
                // dispatch(updateDisplayEvents(employeeId));
                dispatch(updateWorkAbsenceEvents(employeeId))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.REMOVE_ROSTER_ETIME, payload: payload }
    }
    function failure(error) {
        return { type: types.REMOVE_ROSTER_ETIME_FAILURE, error }
    }
}

export function fetchCurrentUserETime(options) {
    return function(dispatch) {
        return rosterService
            .fetchEmployeeETime(options)
            .then(currentUserETimePayload => {
                dispatch(success(currentUserETimePayload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.FETCH_CURRENT_USER_ETIME, payload: payload }
    }
    function failure(error) {
        return { type: types.FETCH_CURRENT_USER_ETIME_FAILURE, error }
    }
}

export function copyInsertEvents(options) {
    return function(dispatch) {
        return rosterService
            .copyInsertEvents(options)
            .then(currentUserETimePayload => {
                dispatch(success(currentUserETimePayload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.UPDATE_ROSTER_ETIME, payload: payload }
    }
    function failure(error) {
        return { type: types.UPDATE_ROSTER_ETIME_FAILURE, error }
    }
}

export function copyInsertWeekEvents(options) {
    return function(dispatch) {
        return rosterService
            .copyInsertEvents(options)
            .then(currentUserETimePayload => {
                dispatch(success(currentUserETimePayload))
            })
            .catch(error => {
                dispatch(failure(error.toString()))
            })
    }

    function success(payload) {
        return { type: types.UPDATE_WEEK_EVENTS, payload: payload }
    }
    function failure(error) {
        return { type: types.UPDATE_WEEK_EVENTS_FAILURE, error }
    }
}
